<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">

      <div class="top_header">
        <div class="item">
          <div class="label">
            {{'CLOSEDTRIPSDETAILS.title'| translate}}
          </div>
  
        </div>
        <div class="item all_unit_sec">
          <div>
            <mat-slide-toggle (change)="allUnitData()">
            </mat-slide-toggle>
            <span class="toggle">{{'INPLANT.allUnit'| translate}}</span>
          </div>
          <div class="download_sec" (click)="download();">
            <div> <img src="assets/download-icon-new.svg" alt=""> </div>
          </div>
          <!-- <div class="refresh_btn">
            <mat-icon class="" style="cursor: pointer;" (click)="refresh()">refresh</mat-icon>
          </div> -->
        </div>
      </div>
      <div class="filters_sec">
        <div class="filter">
          <div class="input">
            <input type="text" class="inputField" placeholder="From" [(ngModel)]="fromDate"
              (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
            <mat-datepicker #fromDateInput3 (closed)="getclosedTripsDetails()">
            </mat-datepicker>
            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
          </div>
        </div>
        <div class="filter">
          <div class="input">
            <input type="text" class="inputField" placeholder="To" [(ngModel)]="toDate" (click)="toDateInput3.open()"
              [matDatepicker]="toDateInput3" />
            <mat-datepicker #toDateInput3 (closed)="getclosedTripsDetails()">
            </mat-datepicker>
            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
          </div>
        </div>
        <div style="cursor: pointer;margin-top: 8px;" (click)="getclosedTripsDetails()">
          <img src="assets/refresh-icon.svg" alt="">
        </div>
      </div>
 
        <div class="body">
            <div class="table">
                <table mat-table *ngIf="closedTripsDetail && closedTripsDetail.length;else noData" [dataSource]="closedTripsDetail">

                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.sno'| translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
                    </ng-container>

                    <ng-container matColumnDef="gateentry">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.gateentry'| translate}} </th>
                        <td mat-cell *matCellDef="let element">{{element.entry_no}}</td>
                    </ng-container>


                    <ng-container matColumnDef="vehicle_details">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.vehicle_details'| translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <!-- {{element.vehicle}}<br />{{element.vehicleCapacity}} -->
                            <div *ngIf="element.tracker" (click)="$event.stopPropagation();">
                                <a href="{{ element.tracker }}" target="_blank">
                                    <span>
                                        {{element.vehicle}}<br /><br /> {{element.tripType}}
                                    </span>
                                </a>
                            </div>
                            <div *ngIf="!element.tracker">
                                {{element.vehicle}}<br /><br /> {{element.tripType}}
                            </div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="customerdetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.customerdetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 250px;">{{element.cust_name}} <br /> {{element.destination}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="carrier">
                        <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.shipperDetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element" matTooltip={{element.supportnumber}}> {{element.shipper.parent_name || 'N/A'}}</td>
                      </ng-container>
                    <ng-container matColumnDef="driverdetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.driverdetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}}<br />{{element.mobile}}</td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="yarddetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.yarddetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element">{{element.yardEntry}} <br /> {{element.yardExit}} </td>
                    </ng-container> -->

                    <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.material'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.plant}} </td>
                    </ng-container>

                    <ng-container matColumnDef="plantdetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.plantdetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.plant}} <br /> {{element.plantEntryTime}} <br /> {{element.plantExitTime}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="customerentry">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.customerentry'| translate}} </th>
                        <td mat-cell *matCellDef="let element" > {{element.custEntTime}} <br /> {{element.custExitTIme}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="tripdetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.tripdetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element" > {{element.tripEndType}} <br /> {{element.tripType}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dept_time">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.dept_time'| translate}} </th>
                        <td mat-cell *matCellDef="let element" > {{element.dept_time}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="estimateddistance">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.estimateddistance'| translate}} </th>
                        <td mat-cell *matCellDef="let element" > {{element.estimatedDistance}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="shipmentdetails">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.shipmentdetails'| translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.shipToCode}}  <br />{{element.city}}<br />{{element.state}}<br /> {{element.pincode}}
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> {{'CLOSEDTRIPSDETAILS.action'| translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 60px;">
                            <mat-icon class="more-icon" style="cursor: pointer" [matMenuTriggerFor]="actions"
                                (click)="$event.stopPropagation()">
                                more_vert</mat-icon>
                            <mat-menu #actions="matMenu">
                                <button mat-menu-item
                                    (click)="$event.stopPropagation();openUpdateRemarks(element)">{{'CLOSEDTRIPSDETAILS.edit' |
                                    translate}}</button>
                            </mat-menu>

                        </td>
                    </ng-container> -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row;let i=index; columns: displayedColumns;" [ngClass]="{'highlightTableColor': selectedRowIndex == i}" (click)="getOrderStatus(row,i);">
                    </tr>
                </table>
            </div>
            <mat-paginator fixed [length]="closedTripsDetail ? totalvehicles : 0" [pageSize]="200" style="margin-right: 14px;"
                [pageSizeOptions]="[200, 400, 500]" [showFirstLastButtons]="true" (page)="pageNavigate($event)">
            </mat-paginator>
        </div>
    </div>
</div>
<ng-template #showData>
    <div class="rowDataDialog">
      <div class="dialog_header">
        <div class="dialog_title">{{vehicleNumber}} / {{odNumber}}</div>
        <div class="dialog_close" (click)="showDialogRef.close()">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div class="dialog_body">
  
        <ul *ngFor="let row of rowData">
          <!-- <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.chirpaniEntry'| translate}}</div>
            <div class="descr">{{ row.chirpaniEntry}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.chirpaniExit'| translate}}</div>
            <div class="descr">{{ row.chirpaniExit}}</div>
          </li> -->
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.source_location'| translate}}</div>
            <div class="descr">{{ row.srcLoc || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.destination'| translate}}</div>
            <div class="descr">{{ row.destination || 'N/A'}}</div>
          </li>
          <!-- <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.distance'| translate}}</div>
            <div class="descr">{{ row.distance || 'N/A'}}</div>
          </li> -->
          <!-- <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.doStatus'| translate}}</div>
            <div class="descr">{{ row.doStatus || 'N/A'}}</div>
          </li> -->
          <!-- <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.driver_type'| translate}}</div>
            <div class="descr">{{ row.driver_type || 'N/A'}}</div>
          </li> -->
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.entry_no'| translate}}</div>
            <div class="descr">{{ row.entry_no || 'N/A'}}</div>
          </li>
          <!-- <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.gateintime'| translate}}</div>
            <div class="descr">{{ row.gateintime || 'N/A'}}</div>
          </li>
          
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.gateouttime'| translate}}</div>
            <div class="descr">{{ row.gateouttime || 'N/A'}}</div>
          </li>
         
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.grossWeight'| translate}}</div>
            <div class="descr">{{ row.grossWeight || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.invoiceDate'| translate}}</div>
            <div class="descr">{{ row.invoiceDate || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.loadingPoint'| translate}}</div>
            <div class="descr">{{ row.loadingPoint || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.loadingPointEntry'| translate}}</div>
            <div class="descr">{{ row.loadingPointEntry || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.loadingPointExit'| translate}}</div>
            <div class="descr">{{ row.loadingPointExit || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.per_vehicle_weight'| translate}}</div>
            <div class="descr">{{ row.per_vehicle_weight || 'N/A'}}</div>
          </li>
          <li style="--accent-color:#002563">
            <div class="icon"><i class="fa-brands fa-css3"></i></div>
            <div class="title">{{'CLOSEDTRIPSDETAILS.pickup'| translate}}</div>
            <div class="descr">{{ row.pickup || 'N/A'}}</div>
          </li> -->
        </ul>
      </div>
    </div>
  </ng-template>
<!-- <ng-template #addRemarkDialog>
    <div class="dialog">
      <div class="dialog_header">
        <div class="dialog_title">{{'DEDICATED.addRemark'| translate}}</div>
        <div class="dialog_close" (click)="dialogRef.close()">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div class="dialog_body">
        <div class="input-container editInput">
          <input type="text" class="formField" required="required" [matAutocomplete]="remarks" [(ngModel)]="shipperRemark"
            placeholder="Shipper Remarks" />
          <mat-autocomplete #remarks="matAutocomplete">
            <mat-option *ngFor="let reason of reasons | filter: shipperRemark" [value]="reason">
              <span>{{ reason }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="dialog_footer">
        <div class="dialog_footer_btn" (click)="updateRemarks()">{{'DEDICATED.submit'| translate}}</div>
      </div>
    </div>
  </ng-template> -->
  <ng-template #noData>
    <app-no-data></app-no-data>
  </ng-template>